import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get links list
 * */
export function* getFlagCompliance() {
    const response = yield call(api.getFlagCompliance);

    if (!response.errors.length) {
        yield put({
            type: actionTypes.GET_FLAG_COMPLIANCE.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_FLAG_COMPLIANCE.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetFlagCompliance() {
    while (true) {
        yield take(actionTypes.GET_FLAG_COMPLIANCE.REQUEST);
        yield fork(getFlagCompliance);
    }
}

export default [
    watchGetFlagCompliance,
];




// WEBPACK FOOTER //
// ./app/sagas/flagCompliance.js